// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/v-accordion/dist/v-accordion.min.css
// module id = 291
// module chunks = 0